// extracted by mini-css-extract-plugin
export default {"accountPage":"account_accountPage__+t4Wp","title":"account_title__NbPRa"};